/* eslint-disable @typescript-eslint/naming-convention */
/**
 * Contacts.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export type Salutation = 'NA' | 'Mr' | 'Mrs' | 'Ms' | 'Dr';

export const Salutation = {
    NA: 'NA' as Salutation,
    Mr: 'Mr' as Salutation,
    Mrs: 'Mrs' as Salutation,
    Ms: 'Ms' as Salutation,
    Dr: 'Dr' as Salutation
};
